// extracted by mini-css-extract-plugin
module.exports = {"gameSquare":"GameSquare_gameSquare__2MGeH","reactCSSTransitionGroup":"GameSquare_reactCSSTransitionGroup__3_1C3"};